<mat-card style="padding-bottom: 10px;">
    <app-matspinner *ngIf="isLoading"></app-matspinner>
    <mat-card-header>
      <mat-card-title class="title">Add Vendor</mat-card-title>
    </mat-card-header>
    <mat-divider  class="divider"></mat-divider>
    <mat-card-content>
      <br>
      <div class="container">
        <form [formGroup]="form">
          <div class="row form-row">
  <div class="col-md-2">
    <label class="lbl_fld" for="vendor-name-input">Vendor Name</label><span class="asterick">*</span>
  </div>
  <div class="col-md-4">
    <mat-form-field class="ffs" appearance="outline">
      <input
        matInput
        id="vendor-name-input"
        type="text"
        formControlName="VendorName"
        placeholder="Vendor Name (Max length is 60 characters)"
        (change)="OnVendorChange($event)"
        required
        (keyup)="clearVendorNameDuplicateValidation();"
        autocomplete="off"
      >
      <mat-error *ngIf="form.get('VendorName')?.invalid && (form.get('VendorName')?.touched || form.get('VendorName')?.dirty)">
        {{ errorMessageForVendorName }}
      </mat-error>
    </mat-form-field>
  </div>
</div>
          <!-- <mat-divider  class="divider" style="margin-top: 3%;"></mat-divider> -->
    <br>
      <app-connection-details 
      [inputModel]="vendor">
      </app-connection-details>
    <div class="row" style="margin-bottom: 0%;">
      <div class="col-md-12" style="text-align: center;">
          <button mat-raised-button color="primary" class="btn-save" [disabled]="!this.form.valid || (!this.connectionDetailsComponent?.form.valid && this.connectionDetailsComponent?.panelOpenState)"
          (click)="submitForm()">Save</button>
          <button mat-raised-button color="primary" class="btn-cancel" (click)="onClickCancel()">Cancel</button>
      </div>
    </div>
        </form>
      </div>
    </mat-card-content>
    <br>
    <br>
  </mat-card>
